





































const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100]
const DEFAULT_ITEMS_PER_PAGE = ITEMS_PER_PAGE_OPTIONS[1]

function custValidator(value) {
  return typeof value === 'number' || value === null
}

export default {
  props: {
    totalCount: { type: Number, required: true },
    pageNumber: { type: Number, required: true },
    nextPageNumber: { required: true, validator: custValidator },
    previousPageNumber: { required: true, validator: custValidator },
    itemsPerPage: { type: Number, default: DEFAULT_ITEMS_PER_PAGE }
  },
  data() {
    return {
      itemsPerPageOptions: ITEMS_PER_PAGE_OPTIONS,
      selectedItemsPerPage: this.itemsPerPage || DEFAULT_ITEMS_PER_PAGE,
      dropdownOpenDirection: 'bottom'
    }
  },
  computed: {
    firstItemOnPage() {
      return (this.previousPageNumber || 0) * this.itemsPerPage + 1
    },
    lastItemOnPage() {
      return this.nextPageNumber ? this.pageNumber * this.itemsPerPage : this.totalCount
    },
    itemsPerPageLabel() {
      return this.$tc('pagination.itemsOfTotal', this.totalCount, {
        firstOnPage: this.firstItemOnPage,
        lastOnPage: this.lastItemOnPage,
        total: this.totalCount
      })
    }
  },
  watch: {
    itemsPerPage(newVal) {
      if (newVal && newVal !== this.selectedItemsPerPage)
        this.selectedItemsPerPage = newVal
    },
    '$route.query'(newQuery, oldQuery) {
      if (newQuery.size !== oldQuery.size || newQuery.page !== oldQuery.page)
        this.$emit('change', { page: newQuery.page, size: newQuery.size })
    }
  },
  methods: {
    onChangeSize(event) {
      if (!event) {
        // todo(misha): This should be handled as well in the..
        // ..DropdownField component at Plankton.
        // Should't be emitted event with empty value out of the component.
        this.selectedItemsPerPage = this.itemsPerPage
        return
      }

      this.pushChange(1)
    },
    onClickPrev() {
      this.pushChange(this.previousPageNumber)
      this.scrollToTop()
    },
    onClickNext() {
      this.pushChange(this.nextPageNumber)
      this.scrollToTop()
    },
    onOpenDropdown() {
      const distanceToDocumentBottom =
        document.documentElement.offsetHeight -
        this.$refs.dropdown.offsetTop +
        this.$refs.dropdown.offsetHeight
      if (distanceToDocumentBottom < 200) {
        this.dropdownOpenDirection = 'top'
      } else {
        this.dropdownOpenDirection = 'bottom'
      }
    },
    pushChange(nextPage) {
      if (nextPage)
        this.$router.push({
          query: {
            ...this.$route.query,
            size: this.selectedItemsPerPage,
            page: nextPage
          }
        })
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
